import { render } from "./Jokyo.vue?vue&type=template&id=661d8a88&scoped=true"
import script from "./Jokyo.vue?vue&type=script&lang=js"
export * from "./Jokyo.vue?vue&type=script&lang=js"

import "./Jokyo.vue?vue&type=style&index=0&id=661d8a88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-661d8a88"

export default script